import { createDiv, createDom, makeClickable, removeDom } from "../domUtils.mjs";
import { createError } from "../errorUtils.mjs";
import { Friend } from "../Friend.mjs";
import mockConfig from "./config.mjs";
let dialogOpened = false;
const open = function(platform) {
  if (dialogOpened)
    return Promise.reject(createError("PENDING_REQUEST"));
  dialogOpened = true;
  return new Promise(function(resolve, reject) {
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv("devkit-instant-mock-context-choose", overlay);
    const title = createDom("h1", void 0, container);
    title.innerText = "Invite to Play";
    const closeButton = createDiv("devkit-instant-mock-closeBtn", title);
    makeClickable(closeButton, () => {
      dialogOpened = false;
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
    const list = createDiv(null, container);
    function createItem(opts) {
      const item = createDiv("devkit-instant-mock-context-choose-item", list);
      const icon = createDiv(
        "devkit-instant-mock-context-choose-item-icon",
        item
      );
      createDiv(
        "devkit-instant-mock-context-choose-item-title",
        item
      ).innerText = opts.type === "single" ? opts.friend.name : opts.name;
      createDiv("devkit-instant-mock-context-choose-item-btn", item).innerText = "PLAY";
      if (opts.type === "single")
        icon.style.backgroundImage = "url(" + opts.friend.photo + ")";
      makeClickable(item, () => {
        dialogOpened = false;
        removeDom(overlay);
        resolve(opts);
      });
    }
    createDom("h2", null, list).innerText = "Friends";
    for (const friend of platform.friends) {
      createItem({ type: "single", friend });
    }
    createDom("h2", null, list).innerText = "Groups";
    for (const groupId in mockConfig.group) {
      const group = mockConfig.group[groupId];
      const groupPlayers = group.players.map((playerId) => {
        const mockPlayer = mockConfig.player[playerId];
        return new Friend([mockPlayer.id, mockPlayer.name, mockPlayer.photo]);
      });
      createItem({
        type: "group",
        id: groupId,
        name: group.name,
        players: groupPlayers
      });
    }
    createDom("h2", null, list).innerText = "Tournaments";
    for (const tournamentId in mockConfig.tournament) {
      createItem({
        type: "tournament",
        id: tournamentId,
        name: mockConfig.tournament[tournamentId].name
      });
    }
    setTimeout(() => {
      container.style.top = "1px";
      container.style.opacity = "1";
    }, 100);
  });
};
const friendPicker = { open };
export {
  friendPicker as default
};
